import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getCookie } from './getCookie';
import { fetchNewbuildingDynamicCalltracking } from '../services/newbuildingDynamicCalltracking';
import { sendTelemetry } from '../services/telemetry';
export function handleDynamicCalltracking(_x) {
  return _handleDynamicCalltracking.apply(this, arguments);
}
function _handleDynamicCalltracking() {
  _handleDynamicCalltracking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var blockId, httpApi, logger, platformType, pageType, placeType, announcementId, queryString, analyticClientId, utm, refererUrl, locationUrl, startTime, newbuildingPhone, responseTime, _newbuildingPhone$pho, phone, _newbuildingPhone$not, notFormattedPhone, _responseTime;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          blockId = _ref.blockId, httpApi = _ref.httpApi, logger = _ref.logger, platformType = _ref.platformType, pageType = _ref.pageType, placeType = _ref.placeType, announcementId = _ref.announcementId, queryString = _ref.queryString;
          analyticClientId = getCookie('_ga') || '';
          utm = getCookie('sopr_utm', false) || '';
          refererUrl = document.referrer;
          locationUrl = window.location.href;
          startTime = new Date().getTime();
          _context.prev = 6;
          _context.next = 9;
          return fetchNewbuildingDynamicCalltracking(httpApi, {
            blockId: blockId,
            platformType: platformType,
            pageType: pageType,
            placeType: placeType,
            announcementId: announcementId,
            queryString: queryString,
            refererUrl: refererUrl,
            locationUrl: locationUrl,
            analyticClientId: analyticClientId,
            utm: utm
          });
        case 9:
          newbuildingPhone = _context.sent;
          responseTime = new Date().getTime() - startTime;
          sendTelemetry({
            httpApi: httpApi,
            responseTime: responseTime
          });
          _newbuildingPhone$pho = newbuildingPhone.phone, phone = _newbuildingPhone$pho === void 0 ? null : _newbuildingPhone$pho, _newbuildingPhone$not = newbuildingPhone.notFormattedPhone, notFormattedPhone = _newbuildingPhone$not === void 0 ? null : _newbuildingPhone$not;
          return _context.abrupt("return", {
            phone: phone,
            notFormattedPhone: notFormattedPhone
          });
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](6);
          _responseTime = new Date().getTime() - startTime;
          if (_context.t0.constructor.name === 'HttpTimeoutError') {
            logger.warning('[Degradation]: DynamicCalltracking: Таймаут запроса /v1/get-dynamic-phone/');
            sendTelemetry({
              httpApi: httpApi,
              responseTime: _responseTime
            });
          } else {
            logger.error(_context.t0, {
              message: _context.t0.message,
              stack: _context.t0.stack,
              comment: '[Degradation]: DynamicCalltracking: Ошибка запроса /v1/get-dynamic-phone/'
            });
            sendTelemetry({
              httpApi: httpApi,
              responseTime: _responseTime
            });
          }
          return _context.abrupt("return", {
            phone: null,
            notFormattedPhone: null
          });
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 16]]);
  }));
  return _handleDynamicCalltracking.apply(this, arguments);
}